import {useState} from 'react';

export function useSessionStorage(key, initialValue) {
    const [storeValue, setStoreValue] =useState(()=>{
        try{
            const item = window.sessionStorage.getItem(key)
            return item ? JSON.parse(item) : initialValue;
        }catch (error) {
            return initialValue
        }
    })

     const setValue =value =>{
         try{
            setStoreValue(value);
            window.sessionStorage.setItem(key, JSON.stringify(value))
         }catch(error){
             console.log(error)
         }
     }

    return [storeValue, setValue]
};